"use client";
import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  Button,
  Input,
  Dropdown,
  Label,
} from "@int-traderjoes/ui-components-library";
import { IDocumentApprovalFormData } from "@/context/data.types";
import { DocumentApprovalFormData } from "@/context/data";
import { useTheme } from "@/context";
import { handleInputChange, handleDropdownChange } from "@/utils/helper";
// Function to handle form submission

const NotesNDocumentApprovalForm: React.FC = () => {
  const { darkMode } = useTheme();
  const darkModeClass = darkMode ? "dark" : "light";
  const [formData, setFormData] = useState<IDocumentApprovalFormData>(
    DocumentApprovalFormData
  );


  return (
    <>
      <Box className="bg-white dark:bg-TJ-Dark2 border-TJ-Box-Border dark:border-TJ-Dark border">
        <Box className="w-full h-10 bg-TJ-Box-Light-Grey dark:bg-TJ-Dark3 flex items-center border-b border-b-TJ-Box-Border dark:border-b-TJ-Dark">
          <Typography
            className="p-4 text-base text-TJ-Almost-Black dark:text-TJ-white"
            sx={{ fontWeight: "600" }}
          >
            Notes & Document Approval
          </Typography>
        </Box>
        <form className="p-[1.5rem]">
          <Box className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[1.5rem]">
            <Box>
              <Label className={darkModeClass}>
                Product Creator
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.productCreator || ""}
                onChange={handleInputChange("productCreator", setFormData)}
              />
            </Box>
            <Box>
              <Label className={darkModeClass}>
                Category Manager
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.categoryManager || ""}
                onChange={(event: any) => handleInputChange("categoryManager", setFormData)}
              />
            </Box>
            <Box>
              <Label className={darkModeClass}>
                Working Name of Product
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.workingNameOfProduct || ""}
                // {...register("workingNameOfProduct", { required: true })}
                onChange={handleInputChange("workingNameOfProduct", setFormData)}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                What inspired you to develop this product?
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.inspiration || ""}
                onChange={handleInputChange("inspiration", setFormData)}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                Why is this vendor the best to partner with for this product?
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.vendorPartnerReason || ""}
                onChange={handleInputChange("vendorPartnerReason", setFormData)}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                Have you or another Trader Joe’s Crew Member visited the
                facility where the product would be manufactured? If no when do
                you or another Trader Joe’s Crew Member plan to visit?
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.isFacilityVisitedWithDate || ""}
                onChange={handleInputChange("isFacilityVisitedWithDate", setFormData)}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                Have you confirmed the estimated weekly volume with the vendor?
              </Label>
              <Dropdown
                className={darkModeClass}
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
                name="isEstimatedWeeklyVolumeConfirmed"
                selectedValue={formData.isEstimatedWeeklyVolumeConfirmed}
                onChange={handleDropdownChange(
                  "isEstimatedWeeklyVolumeConfirmed", setFormData
                )}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                Does this vendor currently produce the same or a similar type of
                product?
              </Label>
              <Dropdown
                className={darkModeClass}
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
                name="isVendorProducingSimilarProduct"
                selectedValue={formData.isVendorProducingSimilarProduct}
                onChange={handleDropdownChange(
                  "isVendorProducingSimilarProduct", setFormData
                )}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                Does this vendor currently sell similar product in the US?
              </Label>
              <Dropdown
                className={darkModeClass}
                name="isVendorSellingSimilarProductInUS"
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
                selectedValue={formData.isVendorSellingSimilarProductInUS}
                onChange={handleDropdownChange(
                  "isVendorSellingSimilarProductInUS", setFormData
                )}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                How does this product add value to your category? What need does
                it fill?
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.valueAdditionAndNeed}
                onChange={handleInputChange("valueAdditionAndNeed", setFormData)}
              />
            </Box>
            <Box className="sm:col-span-2 lg:col-span-3">
              <Label className={darkModeClass}>
                What are your thoughts on partnering with this vendor for this
                product?
              </Label>
              <Input
                className={darkModeClass}
                required
                value={formData.thoughtsOnVendor || ""}
                onChange={handleInputChange("thoughtsOnVendor", setFormData)}
              />
            </Box>
          </Box>

          {/* <button type="submit" onClick={}>submit</button> */}
        </form>
        {/* </Box> */}
      </Box>
      <Box className="mt-8 flex justify-end gap-[1.5rem]">
        <Button
          className={darkModeClass}
          size={"large"}
          text={"save as draft"}
          onClick={() => console.log("Clicked")}
        />
        <Button
          className={darkModeClass}
          size={"large"}
          text={"go to next"}
          onClick={() => console.log("Clicked")}
          primary
        />
      </Box>
    </>
  );
};

export default NotesNDocumentApprovalForm;
